import {
  Box,
  FeeBreakdown,
  ListContentIsland,
  Money,
  RateBreakdown,
  Typography,
  useRelativeDateTime,
} from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { ApiExternalOutgoingTransferIntentResponse } from '../../openapi';
import { useUiFees, useUiRate } from './helpers';
import {
  BreakdownListItem,
  BreakdownListItemVariant,
} from '@razz-team/ui-web/src/components/List/BreakdownListItem';

export function OutgoingTransferBreakdown({
  intent,
  variant,
}: {
  intent: ApiExternalOutgoingTransferIntentResponse | null | undefined;
  variant: BreakdownListItemVariant;
}) {
  const { t } = useTranslation();

  const transferAmount = intent?.quote.sourceAmount;
  const targetAmount = intent?.quote.targetAmount;
  const debitAmount = intent?.amount;
  const fees = useUiFees(intent?.fees);
  const rate = useUiRate(intent?.quote);
  const timeToArrive = useRelativeDateTime(intent?.deliveryInfo.estimatedDeliveryDate);

  return (
    <Box width="100%">
      <ListContentIsland sx={{ height: 'unset' }}>
        {variant === 'confirm' ? (
          <BreakdownListItem
            icon="dot"
            title={t('Transfer amount')}
            value={<Money value={targetAmount} />}
            loading={!transferAmount}
            variant={variant}
          />
        ) : null}
        {intent?.quote.fx ? (
          <>
            <RateBreakdown rate={rate} variant={variant} />
            <BreakdownListItem
              icon="equal"
              variant={variant}
              title={t('Converted amount')}
              value={<Money value={transferAmount} />}
              loading={!transferAmount}
            />
          </>
        ) : null}
        <FeeBreakdown fees={fees} side={intent?.quote.fx?.side} variant={variant} />
        <BreakdownListItem
          icon="equal"
          title={t('Amount to debit')}
          value={<Money value={debitAmount} />}
          loading={!transferAmount}
          variant={variant}
        />
      </ListContentIsland>
      {variant === 'form' && timeToArrive ? (
        <Typography variant="body2" color="text.secondary" align="center" padding={2}>
          {t('Time to arrive: {{time}}', { time: timeToArrive })}
        </Typography>
      ) : null}
    </Box>
  );
}
